import styled from 'styled-components';
import { Select } from 'antd';

export const UserEditActionButtons = styled.section`
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
`;

export const SelectRole = styled(Select)`
  .anticon {
    line-height: 0 !important;
  }
`;
